/* MagneGlow search: one overlay for the header field and the icon.
   Uses Shopify's /search/suggest.json plus the editor-managed help topics. No libraries. */
(() => {
  if (window.__mgSearch) return;
  window.__mgSearch = true;

  const STOP = new Set('a an the i my me we do does is are to of for in on and or with can how what why when where which it this that you your'.split(' '));
  const $ = (sel, root = document) => root.querySelector(sel);
  const cache = new Map();
  let opener = null;
  let timer = null;
  let controller = null;
  let cfgCache = null;
  let restoring = false;

  const cfg = () => {
    const el = $('#mg-search-config');
    if (!el) return null;
    if (!cfgCache || cfgCache.el !== el) {
      try { cfgCache = { el, data: JSON.parse(el.textContent) }; } catch (e) { return null; }
    }
    return cfgCache.data;
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const strip = (html) => { const d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); };
  const clip = (s, n) => (s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s);
  const path = (u) => String(u).split('#')[0].split('?')[0];

  const refs = () => {
    const dlg = $('#mg-search');
    if (!dlg) return null;
    return {
      dlg,
      input: $('[data-mg-search-input]', dlg),
      clear: $('[data-mg-search-clear]', dlg),
      quick: $('[data-mg-search-quick]', dlg),
      results: $('[data-mg-search-results]', dlg),
      form: $('.mg-search__form', dlg),
    };
  };

  const triggers = () => document.querySelectorAll('[data-mg-search-open]');
  const setExpanded = (v) => triggers().forEach((t) => t.setAttribute('aria-expanded', v ? 'true' : 'false'));

  const open = (from, text) => {
    const r = refs();
    if (!r || r.dlg.open) return;
    opener = from || document.activeElement;
    r.dlg.showModal();
    setExpanded(true);
    r.input.value = text != null ? text : r.input.value;
    render(true);
    r.input.focus();
    r.input.setSelectionRange(r.input.value.length, r.input.value.length);
  };

  const close = () => {
    const r = refs();
    if (!r || !r.dlg.open) return;
    guardFocus();
    r.dlg.close();
  };

  // The browser hands focus back to the header field when the dialog closes; don't reopen on that.
  const guardFocus = () => {
    restoring = true;
    setTimeout(() => { restoring = false; }, 150);
  };

  const onClosed = () => {
    const r = refs();
    setExpanded(false);
    document.querySelectorAll('[data-mg-search-field]').forEach((f) => { f.value = r ? r.input.value : ''; });
    if (opener && document.contains(opener)) {
      restoring = true;
      opener.focus({ preventScroll: true });
      restoring = false;
    }
    opener = null;
  };

  /* ---------- help topic matching ---------- */
  const matchTopics = (q, topics) => {
    const query = q.toLowerCase().trim();
    const tokens = query.split(/[^a-z0-9]+/).filter((t) => t.length > 1 && !STOP.has(t));
    const scored = [];
    topics.forEach((t) => {
      const kws = String(t.k || '').toLowerCase().split(',').map((k) => k.trim()).filter(Boolean);
      const title = String(t.t || '').toLowerCase();
      const extra = String(t.x || '').toLowerCase();
      let score = 0;
      kws.forEach((k) => {
        if (k === query) score += 8;
        else if (query.length > 2 && (query.includes(k) && k.length > 2)) score += 5;
        else if (query.length > 2 && k.startsWith(query)) score += 4;
      });
      tokens.forEach((tok) => {
        let hit = 0;
        kws.forEach((k) => {
          k.split(/[^a-z0-9]+/).forEach((w) => {
            if (w.length < 2) return;
            if (w === tok) hit = Math.max(hit, 3);
            else if (tok.length > 2 && (w.startsWith(tok) || (w.length > 2 && tok.startsWith(w)))) hit = Math.max(hit, 2);
          });
        });
        if (title.includes(tok)) hit = Math.max(hit, 2);
        if (extra.includes(tok)) hit = Math.max(hit, 1);
        score += hit;
      });
      if (score >= 2) scored.push({ t, score });
    });
    return scored.sort((a, b) => b.score - a.score).map((s) => s.t);
  };

  /* ---------- rendering ---------- */
  const highlight = (text, q) => {
    const safe = esc(text);
    const words = q.toLowerCase().split(/\s+/).filter((w) => w.length > 2 && !STOP.has(w));
    if (!words.length) return safe;
    const re = new RegExp('(' + words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'ig');
    return safe.replace(re, '<mark>$1</mark>');
  };

  const item = (o, q, c) => {
    const thumb = c.thumbs && o.img ? `<img class="mg-search__thumb" src="${esc(o.img)}" alt="" loading="lazy" width="48" height="48">` : '';
    const ex = c.excerpts && o.ex ? `<span class="mg-search__item-excerpt">${highlight(o.ex, q)}</span>` : '';
    return `<li><a class="mg-search__item" href="${esc(o.url)}" data-mg-search-item>${thumb}<span class="mg-search__item-text"><span class="mg-search__tag">${esc(o.tag)}</span><span class="mg-search__item-title">${highlight(o.title, q)}</span>${ex}</span><span class="mg-search__arrow" aria-hidden="true">&rarr;</span></a></li>`;
  };

  const group = (label, rows, q, c) => (rows.length
    ? `<section class="mg-search__group"><p class="mg-search__label">${label}</p><ul class="mg-search__list">${rows.map((o) => item(o, q, c)).join('')}</ul></section>`
    : '');

  const paint = (q, data, c) => {
    const r = refs();
    if (!r) return;
    const topics = c.help ? matchTopics(q, c.topics || []).slice(0, 4) : [];
    const helpRows = topics.map((t) => ({ tag: 'FAQ / HELP', title: t.t, ex: t.x, url: t.u }));
    const helpPaths = new Set(topics.map((t) => path(t.u)));
    const toks = q.toLowerCase().split(/[^a-z0-9]+/).filter((t) => t.length > 2 && !STOP.has(t));
    const relevant = (p) => { const hay = [p.title, (p.tags || []).join(' '), p.type, strip(p.body)].join(' ').toLowerCase(); return toks.some((t) => hay.includes(t)); };
    const products = c.products ? (data.products || []).filter(relevant).map((p) => ({ tag: 'PRODUCT', title: p.title, ex: clip(strip(p.body).split(/(?<=[.!?])\s/)[0] || '', 110), url: p.url, img: p.featured_image && p.featured_image.url ? p.featured_image.url : p.image })) : [];
    const pages = c.pages ? (data.pages || []).filter((p) => !helpPaths.has(path(p.url))).map((p) => ({ tag: 'GUIDE', title: p.title, ex: clip(strip(p.body), 110), url: p.url })) : [];
    const articles = c.articles ? (data.articles || []).map((a) => ({ tag: 'ARTICLE', title: a.title, ex: clip(strip(a.body), 110), url: a.url, img: a.image })) : [];
    const total = helpRows.length + products.length + pages.length + articles.length;
    const viewAll = `${c.searchUrl}?q=${encodeURIComponent(q)}&type=product,page,article`;

    if (!total) {
      const tpl = $('[data-mg-search-fallback]', r.dlg);
      const links = tpl ? tpl.innerHTML : '';
      r.results.innerHTML = `<p class="mg-search__empty-title">We couldn&rsquo;t find that.</p><p class="mg-search__empty-sub">Try one of these:</p><ul class="mg-search__list mg-search__list--quick">${links}<li><a class="mg-search__item" href="${esc(c.contactUrl)}" data-mg-search-item><span class="mg-search__item-text"><span class="mg-search__item-title">Contact us</span></span><span class="mg-search__arrow" aria-hidden="true">&rarr;</span></a></li></ul>`;
      return;
    }
    r.results.innerHTML = group('FAQ / HELP', helpRows, q, c) + group('GUIDES + RESOURCES', pages, q, c) + group('PRODUCTS', products, q, c) + group('ARTICLES', articles, q, c)
      + `<a class="mg-btn mg-btn--solid mg-search__all" href="${esc(viewAll)}" data-mg-search-item>View all results for &lsquo;${esc(q)}&rsquo; &rarr;</a>`;
  };

  const render = (immediate) => {
    const r = refs();
    const c = cfg();
    if (!r || !c) return;
    const q = r.input.value.trim();
    r.clear.hidden = !r.input.value;
    clearTimeout(timer);
    if (controller) controller.abort();

    if (q.length < 2) {
      r.results.hidden = true;
      r.results.innerHTML = '';
      if (r.quick) r.quick.hidden = false;
      r.input.setAttribute('aria-expanded', 'false');
      return;
    }
    if (r.quick) r.quick.hidden = true;
    r.results.hidden = false;
    r.input.setAttribute('aria-expanded', 'true');

    const needsFetch = c.predictive && (c.products || c.pages || c.articles);
    const key = q.toLowerCase();
    if (!needsFetch) { paint(q, {}, c); return; }
    if (cache.has(key)) { paint(q, cache.get(key), c); return; }

    // Help topics are instant; native results follow after the debounce.
    paint(q, {}, c);
    const noMatchYet = !r.results.querySelector('.mg-search__group');
    if (noMatchYet) r.results.innerHTML = '<div class="mg-search__skeleton"></div><div class="mg-search__skeleton"></div><div class="mg-search__skeleton"></div>';

    timer = setTimeout(async () => {
      controller = new AbortController();
      const types = [c.products && 'product', c.pages && 'page', c.articles && 'article'].filter(Boolean).join(',');
      const url = `${c.searchUrl}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=${types}&resources[limit]=${c.max}&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,body,tag,product_type,variants.title`;
      try {
        const res = await fetch(url, { signal: controller.signal });
        const json = await res.json();
        const data = (json.resources && json.resources.results) || {};
        cache.set(key, data);
        if (refs().input.value.trim().toLowerCase() === key) paint(q, data, c);
      } catch (e) {
        if (e.name !== 'AbortError') paint(q, {}, c);
      }
    }, immediate ? 0 : 220);
  };

  /* ---------- events (delegated so section re-renders in the editor keep working) ---------- */
  document.addEventListener('click', (e) => {
    const trg = e.target.closest('[data-mg-search-open]');
    if (trg) { e.preventDefault(); open(trg, trg.matches('[data-mg-search-field]') ? trg.value : undefined); return; }
    if (e.target.closest('[data-mg-search-close]')) { close(); return; }
    const r = refs();
    if (!r) return;
    if (e.target.closest('[data-mg-search-clear]')) { r.input.value = ''; render(true); r.input.focus(); return; }
    if (e.target === r.dlg) close();
  });

  document.addEventListener('focusin', (e) => {
    const f = e.target.closest && e.target.closest('[data-mg-search-field]');
    if (f && !restoring && !document.querySelector('#mg-search[open]')) open(f, f.value);
  });

  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-mg-search-headerform]');
    if (!f) return;
    e.preventDefault();
    open($('[data-mg-search-field]', f), $('[data-mg-search-field]', f).value);
  });

  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-mg-search-input]')) render(false);
  });

  document.addEventListener('keydown', (e) => {
    const r = refs();
    if (!r || !r.dlg.open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    const items = [...r.dlg.querySelectorAll('[data-mg-search-item]')].filter((a) => a.offsetParent !== null);
    const i = items.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      (items[i + 1] || items[0] || r.input).focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (i <= 0) r.input.focus(); else items[i - 1].focus();
    }
  });

  document.addEventListener('cancel', (e) => { if (e.target && e.target.id === 'mg-search') guardFocus(); }, true);
  document.addEventListener('close', (e) => { if (e.target && e.target.id === 'mg-search') onClosed(); }, true);

  /* ---------- /search page: help topics + fallback links share the header's data ---------- */
  const initResultsPage = () => {
    const c = cfg();
    if (!c) return;
    const help = $('[data-mg-results-help]');
    if (help && c.help) {
      const rows = matchTopics(help.dataset.q || '', c.topics || []).slice(0, 4).map((t) => ({ tag: 'FAQ / HELP', title: t.t, ex: t.x, url: t.u }));
      if (rows.length) {
        help.innerHTML = `<p class="mg-sr__label">FAQ / HELP</p><ul class="mg-sr__list">${rows.map((o) => item(o, help.dataset.q || '', { excerpts: true, thumbs: false })).join('')}</ul>`;
        help.hidden = false;
        const empty = $('[data-mg-results-empty]');
        const title = empty && $('.mg-sr__empty-title');
        if (empty && title && $('.mg-sr__group') === null) { empty.hidden = true; }
      }
    }
    const fb = $('[data-mg-results-fallback]');
    const tpl = $('[data-mg-search-fallback]');
    if (fb && tpl) fb.innerHTML = tpl.innerHTML + `<li><a class="mg-search__item" href="${esc(c.contactUrl)}"><span class="mg-search__item-text"><span class="mg-search__item-title">Contact us</span></span><span class="mg-search__arrow" aria-hidden="true">&rarr;</span></a></li>`;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initResultsPage); else initResultsPage();

  // Theme editor: show the overlay while one of its blocks is being edited.
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target.closest && e.target.closest('#mg-search')) open(null, '');
  });
  document.addEventListener('shopify:block:deselect', () => close());
})();
